import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CrownOutlined } from '@ant-design/icons';
import { useSubscription } from '../hooks/useSubscription';

const SubscriptionMenuButton = ({ collapsed }) => {
  const { t } = useTranslation();
  const subscription = useSubscription();
  const [cachedSubscription, setCachedSubscription] = useState(null);

  // Memoize the effective subscription to prevent unnecessary re-renders
  const effectiveSubscription = useMemo(() => {
    if (subscription) {
      setCachedSubscription(subscription);
      return subscription;
    }
    return cachedSubscription;
  }, [subscription, cachedSubscription]);

  const hasSubscription = effectiveSubscription?.hasSubscription?.();
  const hasProblem = hasSubscription && effectiveSubscription?.hasSubscriptionProblem?.();

  const isUpgraded = hasSubscription;

  const linkPath = isUpgraded ? '/subscription' : '/pricing';
  const labelText = isUpgraded
    ? t('navigation_header.manage_subscription')
    : t('navigation_header.upgrade');

  const iconNode = (
    <CrownOutlined />
  );

  const problemBadgeNode = hasProblem ? (
    <span
      style={{
        display: 'inline-block',
        minWidth: 16,
        height: 16,
        lineHeight: '16px',
        borderRadius: 8,
        backgroundColor: '#ff4d4f',
        color: '#fff',
        fontSize: 12,
        textAlign: 'center',
        marginLeft: 6
      }}
    >
      !
    </span>
  ) : null;

  return {
    key: '8',
    icon: iconNode,
    title: labelText,
    label: (
      <Link
        to={linkPath}
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {!collapsed && (
          <span style={{ display: 'inline-flex', alignItems: 'center' }}>
            <span>{labelText}</span>
            {problemBadgeNode}
          </span>
        )}
      </Link>
    ),
  };
};

export default SubscriptionMenuButton;